export default "__VITE_ASSET__f0jpCl8s__"